import { Maybe } from '@crocodille/util';
import { DefaultNamespace, TFuncKey, TFunction } from 'react-i18next';

export function translateError<E extends TFuncKey<DefaultNamespace>>(
  t: TFunction<DefaultNamespace>,
  error: Maybe<E>,
  params?: Record<string, unknown>,
): string | null {
  return error
    ? t(`common:${error}` as TFuncKey<DefaultNamespace>, params)?.toString?.()
    : null;
}
